<template>
    <div id="app">
        <router-view/>
    </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
    name: 'app',
    data () {
        return {}
    },
}
</script>
<style scoped>
#app {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
</style>
